import { useEffect, useState } from 'react';
import { WorkEntry } from '../models';
import { DataStore } from '@aws-amplify/datastore';
import { convert } from '../util/date-helpers';

export interface LoadedMonth {
    year: number;
    month: number;
    workHours: number;
    requiredHours: number;
}

export const useLoadEntries = () => {
    const [loadedMonths, setLoadedMonths] = useState<LoadedMonth[]>();

    useEffect(() => {
        const subscription = DataStore.observeQuery(WorkEntry).subscribe((sub) => {
            const map = new Map<string, LoadedMonth>();
            for (const item of sub.items) {
                const [year, month] = item.date.split('-');
                const mapId = `${year}-${month}`;

                if (!map.has(mapId)) {
                    map.set(mapId, { year: Number(year), month: Number(month), workHours: 0, requiredHours: 0 });
                }

                const mapEntry = map.get(mapId)!;

                map.set(mapId, {
                    ...mapEntry,
                    workHours: mapEntry.workHours + item.duration,
                    requiredHours: item.isWorkDay ? mapEntry.requiredHours + 8 : mapEntry.requiredHours
                });
            }

            setLoadedMonths(
                Array.from(map.values()).sort((a, b) => {
                    if (a.year !== b.year) {
                        return a.year - b.year;
                    }

                    return a.month - b.month;
                })
            );
        });

        return () => subscription.unsubscribe();
    }, []);

    return loadedMonths;
};

export const useLoadEntriesForMonth = (inputYear: number, inputMonth: number) => {
    const [workEntries, setWorkEntries] = useState<WorkEntry[]>();
    const {
        year,
        nextYear,

        month,
        nextMonth
    } = convert(inputYear, inputMonth);

    useEffect(() => {
        const subscription = DataStore.observeQuery(WorkEntry, (entry) =>
            entry.date('ge', `${year}-${month}`).date('lt', `${nextYear}-${nextMonth}`)
        ).subscribe((sub) => setWorkEntries(sub.items));

        return () => subscription.unsubscribe();
    }, [month, nextMonth, nextYear, year]);

    return workEntries;
};
